<template>
  <a-layout
    class="body-section"
    :style="{
      marginLeft: isSideMenuCollapsed ? '80px' : '240px',
    }"
  >
    <a-layout-content :style="{ padding: '0 24px' }">
      <router-view v-slot="{ Component }">
        <keep-alive include="Statistics,DepartmentStatistic">
          <component
            :is="Component"
            :key="$route.path"
          />
        </keep-alive>
      </router-view>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  setup () {
    const { state } = useStore()
    const isSideMenuCollapsed = computed(() => state.app.isSideMenuCollapsed)

    return {
      isSideMenuCollapsed
    }
  }
})

</script>

<style lang="less" scoped>
.body-section {
  margin-top: 48px;
}
</style>
